import "angular";

/**
 * The module that will contain our auto focus directives.
 *
 * @type {*|module}
 */
// eslint-disable-next-line no-undef
var focusDirectives = angular.module("focusDirectives", []);

var autoFocus = function () {
    "use strict";
    return {
        restrict: "A",
        require: "?regEx",
        scope: {},
        replace: false,

        link: {
            pre: function preLink(scope, element, attr) {
                //console.debug('prelink called');
                // this fails since the element hasn't rendered
                //element[0].focus();
            },
            post: function postLink(scope, element, attr) {
                //console.debug('postlink called');
                // this succeeds since the element has been rendered
                element[0].focus();
            }
        }
    };
};

focusDirectives.directive("autoFocus", autoFocus);
export default focusDirectives;
